import React from "react";
import styles from "./page2.scss";
import book1 from "./book1.png";
import book2 from "./book2.png";
import book3 from "./book3.png";
import book4 from "./book4.png";
import app from "./app.jpg";
import { getRem } from "../../func";
import qrcode_ios from "./qrcode_ios.png";
import qrcode_android from "./qrcode_android.png";

function Page2(props) {
  return (
    <div className={styles["page2"]} ref={props.myRef}>
      <div className={styles["page2-left"]}>
        <div className={styles["page2-left-main"]}>
          <div className={styles["page2-left-pics"]}>
            <div className={styles["page2-left-pic"]}>
              <img alt="" src={book1} />
            </div>

            <div className={styles["page2-left-pic"]}>
              <img alt="" src={book2} />
            </div>

            <div className={styles["page2-left-pic"]}>
              <img alt="" src={book3} />
            </div>

            <div className={styles["page2-left-pic"]}>
              <img alt="" src={book4} />
            </div>
          </div>

          <div className={styles["page2-left-content"]}>
            <div className={styles["page2-left-number"]}>2</div>

            <div className={styles["page2-left-title"]}>{"趋势实体书籍"}</div>

            <br></br>

            <div
              className={`${styles["page2-left-title"]} ${styles.link}`}
              style={{ marginBottom: getRem(14) }}
              onClick={() =>
                window.open(
                  "https://2019.wow-trend.com/column/?nav_id=31&gender_id=72105"
                )
              }
            >
              {"TRENDING BOOKS"}
            </div>

            <div
              className={`${styles["page2-left-desc1"]} animate1-wrapper`}
              style={{ marginBottom: getRem(19) }}
            >
              <div
                r="255"
                g="253"
                b="164"
                className={`maskBlock animate1`}
                style={{ background: "rgb(255, 253, 164)" }}
              />
              {
                "为呈现更具参考及收藏价值的趋势灵感观点WOW-TREND每季度发行一系列具有战略方向及设计思维的趋势实体书籍。"
              }
            </div>

            <div className={`${styles["page2-left-desc2"]} animate1-wrapper`}>
              <div
                r="255"
                g="253"
                b="164"
                className={`maskBlock animate1`}
                style={{ background: "rgb(255, 253, 164)" }}
              />
              {"企划类：主题企划、色彩企划、面料企划、图案企划、工艺企划"}
            </div>
            <div className={`${styles["page2-left-desc2"]} animate1-wrapper`}>
              <div
                r="255"
                g="253"
                b="164"
                className={`maskBlock animate1`}
                style={{ background: "rgb(255, 253, 164)" }}
              />
              {"趋势类：色彩、T台、街拍、部件细节"}
            </div>
            <div className={`${styles["page2-left-desc2"]} animate1-wrapper`}>
              <div
                r="255"
                g="253"
                b="164"
                className={`maskBlock animate1`}
                style={{ background: "rgb(255, 253, 164)" }}
              />
              {"单品趋势：羽绒、毛衫、大衣、连衣裙、其它单品"}
            </div>

            <div className={styles["page2-left-legend"]}>
              <div className={styles["legend-left"]}>
                <div
                  className={styles["legend-item"]}
                  style={{ textAlign: "left" }}
                >
                  企划
                </div>
                <div
                  className={styles["legend-item"]}
                  style={{ textAlign: "left" }}
                >
                  趋势
                </div>
                <div
                  className={styles["legend-item"]}
                  style={{ textAlign: "left" }}
                >
                  单品趋势
                </div>
              </div>

              <div className={styles["legend-center"]}>
                <i className="iconfont iconxiangqingdanchuang-guanbi" />
              </div>

              <div className={styles["legend-right"]}>
                <div className={styles["legend-item"]}>面料详情</div>
                <div className={styles["legend-item"]}>辅料细节</div>
                <div className={styles["legend-item"]}>专色色卡</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles["page2-right"]}>
        <div className={styles["page2-right-main"]}>
          <div className={`${styles["page2-right-title"]} animate1-wrapper`}>
            <div
              r="255"
              g="255"
              b="255"
              className={`maskBlock animate1`}
              style={{ background: "rgb(255, 255, 255)" }}
            />
            WOW-TREND热点趋势APP，是立足中国的时尚产业垂直服务平台、是设计师快速精准获取时尚灵感
            的新工具，是随时随地可浏览的时尚潮流生活社区。
          </div>

          <div className={styles["page2-right-center"]}>
            <div className={styles["page2-right-main-left"]}>
              {[
                "热门趋势",
                "色彩推荐",
                "品牌趋势",
                "零售市场",
                "喜好推荐",
                "智能搜款",
                "全球博主",
                "智能识图",
                "发布会",
                "团队协作",
              ].map((item) => {
                return (
                  <div key={item} className={styles["page2-right-item"]}>
                    {item}
                  </div>
                );
              })}

              <div className={styles["page2-right-main-left-qrcode"]}>
                <div className={styles["qrcode-item"]}>
                  <img alt="" src={qrcode_ios} />

                  <div className={styles["qrcode-item-text"]}>
                    App Store 下载
                  </div>
                </div>

                <div
                  className={styles["qrcode-item"]}
                  style={{ marginLeft: getRem(20) }}
                >
                  <img alt="" src={qrcode_android} />

                  <div className={styles["qrcode-item-text"]}>Android 下载</div>
                </div>
              </div>
            </div>

            <div className={styles["page2-right-main-right"]}>
              <img alt="" src={app} />
            </div>
          </div>

          <div className={styles["page2-right-footer"]}>
            <div className={styles["page2-right-number"]}>3</div>
            <div>
              <div className={styles["page2-right-footer-title"]}>
                热点趋势APP
              </div>
              <div className={styles["page2-right-footer-title"]}>
                APPLICATION
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page2;
